module.exports = __webpack_public_path__ + "static/media/people-2564420__340.84d73fa8.jpg";